import { render, staticRenderFns } from "./ExpandingOption.vue?vue&type=template&id=0fe729f8&scoped=true&"
import script from "./ExpandingOption.vue?vue&type=script&lang=js&"
export * from "./ExpandingOption.vue?vue&type=script&lang=js&"
import style0 from "./ExpandingOption.vue?vue&type=style&index=0&id=0fe729f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe729f8",
  null
  
)

export default component.exports